var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sChip',{staticClass:"status-chip",attrs:{"background":_vm.colorProps.background,"color":_vm.colorProps.color,"data-qa":"status"}},[_c('TooltipedText',{staticClass:"status-chip__text",attrs:{"max-length":25,"value":_vm.statusText}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }